import {BlockType, Blocks} from '../blocks/Blocks'
import {Hero, HeroType} from '../layout/Hero'
import {TeamsInfo, TeamsInfoRegisterType} from './teams/TeamsInfo'

import {Breadcrumbs} from '../layout/Breadcrumbs'
import {Layout} from '../layout/Layout'
import {PageData} from '../../types'
import React from 'react'
import {TeamsSearch} from './teams/TeamsSearch'
import {style} from '../../util/style'
import {wrap} from '@codeurs/front'

const styles = style('teams')

export type TeamsType = {
	hero: HeroType
	blocks?: Array<BlockType>
	moneyGathered: string
	registration?: TeamsInfoRegisterType
}

export const Teams: React.FC<PageData & TeamsType> = wrap(Layout)(
	({...props}) => {
		const {
			parents,
			title,
			hero,
			blocks,
			moneyGathered,
			numberOfTeams,
			registration
		} = props

		return (
			<div className={styles()}>
				<Hero {...hero} title={(hero && hero.title) || title} />
				<Breadcrumbs parents={parents} title={title} />
				<TeamsInfo
					money={moneyGathered}
					numberOfTeams={numberOfTeams}
					registration={registration}
				/>
				<div className={styles('overview')}>
					<TeamsSearch editionId={parents[0]?.id} />
				</div>
				<Blocks blocks={blocks} container={true} />
			</div>
		)
	}
)
